import { FC, useEffect, useState } from "react"
import { useUser } from "../../stores/user"
import { UserSectionProps } from "../../pages/User"
import useError from "../../hooks/useError"
import {
  SubscriptionsService,
  Challenge,
  ChallengesService
} from "../../sdk"
import PageLoader from "../PageLoader"
import ChallengeCard from "../ChallengeCard"

const UserSubscriptions: FC<UserSectionProps> = ({ user }) => {
  const setSubscriptions = useUser(state => state.setSubscriptions)
  const subscriptions = useUser(state => state.subscriptions)
  const [loadingUserChallenges, setLoadingUserChallenges] = useState<boolean>(!subscriptions)

  const { handleError } = useError()

  useEffect(() => {
    if (!subscriptions) {
      void (async(): Promise<void> => {
        try {
          const { data: subscriptions } = await SubscriptionsService.listUsersSubscriptions({
            paginator: { offset: 0, limit: 100 },
            filters: { userId: Number(user.id) }
          })
          const challenges = await Promise.all(subscriptions.map(({ challengeId }) => ChallengesService.getChallenge({ handler: { challengeId } })))
          setSubscriptions(challenges.map(({ data }) => data) as Challenge[])
        } catch (err) {
          handleError(err)
        }
      })()
    }
    setLoadingUserChallenges(false)
  }, [])

  return (
    <>
      {loadingUserChallenges ?
        <PageLoader className="relative mt-8" />
        :
        subscriptions && subscriptions.length > 0 ?
          <>
            <h2 className="text-4xl font-semibold mb-10">Iscrizioni</h2>
            <div className="grid grid-cols-3 gap-6">
              {(subscriptions as Challenge[]).map((challenge) => {
                return (
                  <ChallengeCard
                    challenge={challenge}
                    key={challenge.id}
                  />
                )
              })}
            </div>
          </>
          :
          <div>L'utente non è iscritto a nessuna challenge.</div>
      }
    </>
  )
}

export default UserSubscriptions